// src/components/Card.js
import React from "react";
import "../../../src/style.css";

const ProductGridHealth = ({ image, title, subtitle }) => {
  return (
    <div className="custom-card p-4 " >
      <div className="row">

        <div className="col-8">
          <p className="fw-bold text-center p-2 mt-2" style={{ fontSize: '12px' }}>{title}</p>
        </div>
        <div className="col-4 d-flex justify-content-center">
          <img src={image} className="bundlecard-img text-center" alt={title} width='70%' />
        </div>
      </div>

    </div>
  );
};

export default ProductGridHealth;
